export const H1 = `<svg title="H1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
<path d="M3.74023 11.0303H12.4844V4H14.2354V20H12.4844V12.5879H3.74023V20H2V4H3.74023V11.0303ZM21 20H19.5V14.4766H19.4492L17.7393 15.5762V14.1738L19.5625 13H21V20Z" fill="currentcolor"/>
</svg>`;